// get cssgrid working for the extra +15 button et al.
// import './layout.css';
import { smlr } from '../../util.js';
import m from 'mithril';
import { preambleMC} from './preamble.js';
import { gsap } from 'gsap';
import { ExpoScaleEase } from "gsap/EasePack";
gsap.registerPlugin(ExpoScaleEase);

let breatheMC = {
  oncreate: function(vnode) {
    let tl = gsap.timeline();
    tl.to(".dot", {scale: 2, duration: 4, "background-color": "#0000ff", ease: "expoScale(0.5,7,power1.inOut)",}); // BLUE
    tl.to(".dot", {scale: 0.4, duration: 8, "background-color": "#00ff00", ease: "expoScale(0.5,7,power1.inOut)",}, "+=7"); // BLUE
    tl.repeat(-1); // repeat indefinitely

    let t2 = gsap.timeline();
    t2.repeatDelay(0);
    t2.to(".counter", {duration:1, text: "1", ease: "none"});
    t2.to(".counter", {duration:1, text: "2", ease: "none"});
    t2.to(".counter", {duration:1, text: "3", ease: "none"});
    t2.to(".counter", {duration:1, text: "4", ease: "none"});

    t2.to(".counter", {duration:1, text: "1", ease: "none"});
    t2.to(".counter", {duration:1, text: "2", ease: "none"});
    t2.to(".counter", {duration:1, text: "3", ease: "none"});
    t2.to(".counter", {duration:1, text: "4", ease: "none"});
    t2.to(".counter", {duration:1, text: "5", ease: "none"});
    t2.to(".counter", {duration:1, text: "6", ease: "none"});
    t2.to(".counter", {duration:1, text: "7", ease: "none"});
    
    t2.to(".counter", {duration:1, text: "1", ease: "none"});
    t2.to(".counter", {duration:1, text: "2", ease: "none"});
    t2.to(".counter", {duration:1, text: "3", ease: "none"});
    t2.to(".counter", {duration:1, text: "4", ease: "none"});
    t2.to(".counter", {duration:1, text: "5", ease: "none"});
    t2.to(".counter", {duration:1, text: "6", ease: "none"});
    t2.to(".counter", {duration:1, text: "7", ease: "none"});
    t2.to(".counter", {duration:1, text: "8", ease: "none"});

    t2.repeat(-1); // repeat indefinitely

	},
  view: function(e) {
    let result = m("span", {
      class: "dot",
    });
    return(result);
  }
};

let counterMC = {
  view: function(vnode) {
    return(m("div", {
      class: "counter"
    }, `0`));
  }
};

let splash478 = {
  view: function(vnode) {
    var result = [
      m(preambleMC, vnode.attrs),
      m("div", {}, "4-7-8 pattern"),
      m("div", {class: "container"}, [
        m(breatheMC, vnode.attrs),
        m(counterMC, vnode.attrs),
      ]),
    ];
    
    return(result);
  }
};

export { splash478 };